import { ReactNode } from "react";
import "../../styles/auth-pages.css";

type AuthPageLayoutProps = {
  badge?: string;
  title: string;
  subtitle?: ReactNode;
  footerNote?: string;
  footerLink?: ReactNode;
  children: ReactNode;
  headerExtra?: ReactNode;
  centerHeader?: boolean;
};

export default function AuthPageLayout({
  badge,
  title,
  subtitle,
  footerNote,
  footerLink,
  children,
  headerExtra,
  centerHeader = false,
}: AuthPageLayoutProps) {
  return (
    <div className="auth-page">
      <div className="auth-page-inner">
        <div
          className={`auth-page-header${
            centerHeader ? " auth-page-header--centered" : ""
          }`}
        >
          {badge && <span className="auth-badge">{badge}</span>}
          <h1 className="auth-title">{title}</h1>
          {subtitle && <div className="auth-subtitle">{subtitle}</div>}
          {headerExtra}
        </div>
        <div className="auth-form-card">{children}</div>
        {footerLink && <div className="auth-footer-link-row">{footerLink}</div>}
        {footerNote && <p className="auth-footer-note">{footerNote}</p>}
      </div>
    </div>
  );
}
